<template>
  <b-modal
    ref="modal-exchange-imei"
    size="md"
    hide-footer
    centered
    body-class="px-4 pt-2 pb-4"
  >
    <template #modal-title>
      <div class="d-flex align-items-center">
        <span class="imei-modal-icon mr-2">#</span>
        <div>
          <h5 class="mb-0 font-weight-bolder">Chọn IMEI hàng mới</h5>
          <small class="text-muted">
            IMEI phải ở trạng thái NEW tại kho xuất.
          </small>
        </div>
      </div>
    </template>

    <b-input-group class="mb-3">
      <b-input-group-prepend is-text>
        <i class="fas fa-search" style="font-size: 0.8rem"></i>
      </b-input-group-prepend>
      <b-form-input
        v-model="search"
        size="sm"
        autocomplete="off"
        placeholder="Quét hoặc nhập IMEI..."
        @input="onSearch"
      ></b-form-input>
    </b-input-group>

    <div class="imei-list">
      <div v-if="isLoading" class="text-center text-muted py-4">
        <b-spinner small></b-spinner> Đang tải...
      </div>
      <template v-else>
        <label
          v-for="item in filteredImeis"
          :key="item.imeiCode"
          class="imei-row"
          :class="{ active: selectedImei === item.imeiCode }"
        >
          <b-form-radio
            v-model="selectedImei"
            :value="item.imeiCode"
            class="mb-0"
          >
            <span class="imei-code">{{ item.imeiCode }}</span>
          </b-form-radio>
          <b-badge variant="success" class="imei-badge">NEW</b-badge>
        </label>
        <div
          v-if="!filteredImeis.length"
          class="text-center text-muted py-4"
        >
          Không có IMEI khả dụng tại kho xuất.
        </div>
      </template>
    </div>

    <div class="d-flex justify-content-end mt-4">
      <b-button
        variant="secondary"
        size="sm"
        class="mr-2"
        style="width: 80px"
        @click="hide"
        >Hủy</b-button
      >
      <b-button
        variant="primary"
        size="sm"
        :disabled="!selectedImei"
        @click="onApply"
        >Chọn IMEI</b-button
      >
    </div>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';

export default {
  data() {
    return {
      rowId: null,
      productId: null,
      storeId: null,
      search: '',
      selectedImei: null,
      imeis: [],
      isLoading: false,
    };
  },
  computed: {
    filteredImeis() {
      const term = (this.search || '').trim().toLowerCase();
      if (!term) {
        return this.imeis;
      }
      return this.imeis.filter((item) =>
        item.imeiCode.toString().toLowerCase().includes(term),
      );
    },
  },
  methods: {
    show({ rowId, productId, storeId, currentImei }) {
      this.rowId = rowId;
      this.productId = productId;
      this.storeId = storeId;
      this.selectedImei = currentImei || null;
      this.search = '';
      this.imeis = [];
      this.$refs['modal-exchange-imei'].show();
      this.fetchImeis();
    },
    hide() {
      this.$refs['modal-exchange-imei'].hide();
    },
    onSearch() {
      // client-side filter only (computed)
    },
    fetchImeis() {
      if (!this.productId || !this.storeId) {
        return;
      }
      this.isLoading = true;
      ApiService.query('imeis/get-by-product', {
        params: {
          productId: this.productId,
          storeId: this.storeId,
        },
      })
        .then((response) => {
          const data = response.data.data || [];
          this.imeis = data.map((element) => ({
            ...element,
            imeiCode: element.imeiNo,
          }));
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    onApply() {
      if (!this.selectedImei) {
        return;
      }
      this.$emit('selected', {
        rowId: this.rowId,
        imeiCode: this.selectedImei,
      });
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.imei-modal-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: #eef2ff;
  color: #3699ff;
  font-weight: 700;
}
.imei-list {
  max-height: 280px;
  overflow-y: auto;
}
.imei-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 6px;
  padding: 10px 12px;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background-color: #f8f9fa;
  }
  &.active {
    border-color: #3699ff;
    background-color: #eef6ff;
  }
}
.imei-code {
  font-weight: 500;
  color: #181c32;
}
.imei-badge {
  font-size: 0.7rem;
  letter-spacing: 0.04em;
}
</style>
